import Aurelia, {
  LoggerConfiguration,
  ConsoleSink,
  LogLevel
} from 'aurelia';
import { Lastminutetrips } from './pages/lastminutetrips';
import jQuery from 'jquery'

// This function is only needed because Vite default build target "modules" does not support top level await
async function bootstrap() {
  window.jQuery = jQuery;
  window.$ = jQuery;
  await import('paginationjs')

  Aurelia
    .register(
      LoggerConfiguration.create({
        sinks: [ConsoleSink],
        level: LogLevel.error,
      })
    )
    .app(Lastminutetrips)
    .start();
}

bootstrap()